import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  declarations: [AutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TextMaskModule
  ],
  exports: [AutocompleteComponent]
})
export class AutocompleteModule { }
